import React, { Component } from 'react'
import CourseProgressCircle from './CourseProgressCircle'
import classNames from 'classnames';
import { connect } from 'react-redux'
import { getCourseProgress, getCurrentUser } from '../../services/vu'
import HelpText from './HelpText'
import { getTooltipBySlug } from '../../services/reservoir'

const mapStateToProps = ({ courses: { selectedCourseCode, data }, course: { selectedCourse }, currentUser }) => {
  return {
    courseId: selectedCourseCode,
    courseSSPNo: selectedCourse.courseSSPNo,
    courseStage: selectedCourse.courseStage,
    userRole: currentUser.data['role']
  }
}

class CourseProgress extends Component {
  constructor(props) {
    super(props)

    this.state = {
      tooltipLeft: 0,
      tooltipTop: 0,

      courseProgress: this.initialCourseProgress(),
      hoverStates: this.initialHoverStates(),
      creditPointCounter: 0,

      loadingTooltip: true,
      tooltip: ''
    }
  }

  componentDidMount() {
    this.initialiseCourseProgress()

    this.setState({
      loadingTooltip: true
    })

    getTooltipBySlug('credit-points').then((tooltips = []) => {
      this.setState({
        tooltip:
          tooltips &&
          tooltips.length > 0 &&
          tooltips[0].attributes &&
          tooltips[0].attributes.field_body
            ? tooltips[0].attributes.field_body
            : this.state.tooltip,
        loadingTooltip: true
      })
    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.courseId !== this.props.courseId) {
      this.initialiseCourseProgress()
    }
  }

  initialCourseProgress = () => ({
    completionPercentage: 0,
    electronicCoeEndDate: '',
    status: null,
    isEligibleToViewProgress: 'N',
    achievedAsCompleted: 0,
    achievedAsAdvanceStanding: 0,
    enrolledCP: 0,
    requiredToComplete: 0 
  })

  initialiseCourseProgress = () => {
    if (this.props.onLoadStart) {
      this.props.onLoadStart()
    }

    this.setState({
      courseProgress: this.initialCourseProgress(),
      creditPointCounter: 0
    })

    
      getCourseProgress(this.props.courseSSPNo).then(
        courseProgress => {
          const interval = setInterval(() => {
            if (
              this.state.creditPointCounter >=
              (courseProgress.achievedAsCompleted)
            ) {
              clearInterval(interval)
            } else {
              this.setState({
                creditPointCounter: this.state.creditPointCounter + 1
              })
            }
          }, 1000 / (courseProgress.achievedAsCompleted))
  
          this.setState(
            {
              courseProgress: courseProgress
            },
            () => {
              if (this.props.onLoadFinish) {
                this.props.onLoadFinish(courseProgress)
              }
            }
          )
        },
        () => {
          if (this.props.onLoadFail) {
            this.props.onLoadFail()
          }
        }
      )
    
  }

  initialHoverStates = () => ({
    total: false,
    advancedStanding: false,
    completed: false,
    incomplete: false
  })

  handleTotalHover = (x, y) => {
    this.setState({
      hoverStates: {
        ...this.initialHoverStates(),
        total: true
      },
      tooltipLeft: x,
      tooltipTop: y
    })
  }

  handleAdvancedStandingHover = (x, y) => {
    this.setState({
      hoverStates: {
        ...this.initialHoverStates(),
        advancedStanding: true
      },
      tooltipLeft: x,
      tooltipTop: y
    })
  }

  handleCompletedHover = (x, y) => {
    this.setState({
      hoverStates: {
        ...this.initialHoverStates(),
        completed: true
      },
      tooltipLeft: x,
      tooltipTop: y
    })
  }

  handleIncompleteHover = (x, y) => {
    this.setState({
      hoverStates: {
        ...this.initialHoverStates(),
        incomplete: true
      },
      tooltipLeft: x,
      tooltipTop: y
    })
  }

  handleStop = () => {
    this.setState({
      hoverStates: this.initialHoverStates()
    })
  }

  getAdvancedStanding = () => {
    if (this.state.courseProgress.requiredToComplete === 0) {
      return 0
    }

    return (
      this.state.courseProgress.achievedAsAdvanceStanding /
      this.state.courseProgress.requiredToComplete
    )
  }

  getCompleted = () => {
    if (this.state.courseProgress.requiredToComplete === 0) {
      return 0
    }

    return (
      (this.state.courseProgress.achievedAsCompleted - this.state.courseProgress.achievedAsAdvanceStanding) /
      this.state.courseProgress.requiredToComplete
    )
  }

  getIncomplete = () => {
    if (this.state.courseProgress.requiredToComplete === 0) {
      return 0
    }

    return (
      (this.state.courseProgress.enrolledCP) /
      this.state.courseProgress.requiredToComplete
    )
  }

  render() {
    if (this.props.userRole != 'STUDENT') {
      return null
    }

    if (this.state.courseProgress.isEligibleToViewProgress === 'N') {
      return null
    }
    

    return (
      <figure
        className={classNames(
          'course-progress',
          { 'course-progress--total': this.state.hoverStates.total },
          {
            'course-progress--advanced-standing': this.state.hoverStates
              .advancedStanding
          },
          { 'course-progress--completed': this.state.hoverStates.completed },
          { 'course-progress--incomplete': this.state.hoverStates.incomplete }
        )}
      >
        <CourseProgressCircle
          creditPointsCompleted={
            this.state.courseProgress.completionPercentage 
          }
          advancedStanding={0}
          completedUnits={this.getCompleted()}
          incompleteUnits={this.getIncomplete()}
          onTotalHover={this.handleTotalHover}
          onAdvancedStandingHover={this.handleAdvancedStandingHover}
          onCompletedHover={this.handleCompletedHover}
          onIncompleteHover={this.handleIncompleteHover}
          onStop={this.handleStop}
        />
        <figcaption>
          <div
            aria-hidden={true}
            className="course-progress__tooltip-container"
            style={{
              left: this.state.tooltipLeft,
              top: this.state.tooltipTop
            }}
          >
            <span className="course-progress__tooltip course-progress__tooltip--total">
              Total completed
            </span>
            <span className="course-progress__tooltip course-progress__tooltip--advanced-standing">
              Advanced standing
            </span>
            <span className="course-progress__tooltip course-progress__tooltip--completed">
              Passed
            </span>
            <span className="course-progress__tooltip course-progress__tooltip--incomplete">
              Enrolled
            </span>
          </div>
          <HelpText
            className="course-progress__credit-point-total"
            position="top-start"
            toolTip={
              this.state.loadingTooltip && this.state.tooltip
                ? this.state.tooltip
                : ''
            }
            text={
              <span>
                <strong>{this.state.creditPointCounter}</strong> of{' '}
                <strong>
                  {this.state.courseProgress.requiredToComplete}
                </strong>{' '}
                Credit Points completed
              </span>
            }
          />
        </figcaption>
      </figure>
    )
  }
}

export default connect(mapStateToProps)(CourseProgress)
